import styles from './login.module.scss'
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import bgLogin from 'assets/img/bg-login.png'
import { Link, useHistory } from 'react-router-dom'
import { ACTION, ROUTES } from 'consts'
import { Row, Col, Form, Input, Button, notification } from 'antd'

import { register } from 'apis/register'
import { login } from 'apis/auth'
import jwt_decode from 'jwt-decode'

import { useTranslation } from 'react-i18next'

//components
import DropdownLanguage from 'components/dropdown-language'

export default function Login() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const [status, setStatus] = useState(1)
  let history = useHistory()
  const onClickStatus = (data) => {
    setStatus(data)
  }
  const _login = async (body) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await login(body)
      if (res.status === 200) {
        dispatch({ type: ACTION.LOGIN, data: res.data.data })

        //luu branch id len redux
        const dataUser = jwt_decode(res.data.data.accessToken)
        dispatch({ type: 'SET_BRANCH_ID', data: dataUser.data.branch_id })

        history.push(ROUTES.ORDER_LIST)
      } else
        notification.error({
          message: res.data.message || t('login.notification_error_login'),
        })

      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const _register = async (object) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await register(object)
      if (res.status === 200) {
        if (res.data.success) {
          setStatus(1)
          notification.success({ message: t('login.notification_success_register') })
        } else
          notification.error({
            message: res.data.message || t('login.notification_error_register'),
          })
      } else
        notification.error({
          message: res.data.message || t('login.notification_error_register'),
        })

      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const onFinishRegister = async (dataForm) => {
    if (dataForm.password !== dataForm.passwordAgain) {
      notification.warning({ message: t('login.notification_error_password_again') })
      return
    }

    const body = { ...dataForm }
    delete body.passwordAgain
    _register(body)
  }

  return (
    <Row style={{ height: '100%', backgroundColor: '#5B6BE8' }}>
      <Col style={{ width: '100%' }} xs={24} sm={24} md={24} lg={24} xl={8}>
        <Row justify="end">
          <DropdownLanguage />
        </Row>
        <div className={styles['login_choose_parent']}>
          <div style={{ paddingTop: '1rem' }} className={styles['login_choose']}>
            <div
              onClick={() => onClickStatus(1)}
              className={
                status === 1 ? styles['login_choose_status_active'] : styles['login_choose_status']
              }
              style={{
                color: 'white',
                fontWeight: '700',
                marginBottom: '2rem',
                paddingTop: '0.25rem',
                fontSize: '1.5rem',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {t('login.login')}
            </div>
            {/* <div
              onClick={() => onClickStatus(2)}
              className={
                status === 2 ? styles['login_choose_status_active'] : styles['login_choose_status']
              }
              style={{
                color: 'white',
                fontWeight: '700',
                marginBottom: '2rem',
                fontSize: '1.5rem',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {t('login.register')}
            </div> */}
          </div>
        </div>

        {status === 1 ? (
          <div style={{ padding: '0px 40px' }}>
            <Form layout="vertical" form={form} onFinish={_login}>
              <Form.Item
                label={<div style={{ color: 'white' }}>{t('login.username')}</div>}
                name="username"
                rules={[{ required: true, message: t('login.help_username') }]}
              >
                <Input
                  size="large"
                  style={{ borderRadius: '2rem' }}
                  placeholder={t('login.username')}
                />
              </Form.Item>
              <Form.Item
                label={<div style={{ color: 'white' }}>{t('login.password')}</div>}
                name="password"
                rules={[{ required: true, message: t('login.help_password') }]}
              >
                <Input.Password
                  size="large"
                  style={{ borderRadius: '2rem' }}
                  type="password"
                  placeholder={t('login.password')}
                />
              </Form.Item>
              <Row justify="end">
                <Link to={ROUTES.FORGET_PASSWORD} style={{ paddingTop: '0.25rem', color: 'white' }}>
                  {t('login.forgot_password')}?
                </Link>
              </Row>
              <Row justify="center">
                <Form.Item>
                  <Button
                    style={{
                      background: '#000000',
                      borderRadius: '2rem',
                      height: '2.5rem',
                      color: 'white',
                      border: 'none',
                    }}
                    htmlType="submit"
                  >
                    {t('login.login')}
                  </Button>
                </Form.Item>
              </Row>
            </Form>
          </div>
        ) : (
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinishRegister}
            style={{ padding: '0px 40px' }}
          >
            <Form.Item
              label={<div style={{ color: 'white' }}>{t('login.phone')}</div>}
              name="phone"
              rules={[{ required: true, message: t('login.help_phone') }]}
            >
              <Input style={{ width: '100%' }} size="large" placeholder={t('login.phone')} />
            </Form.Item>
            <Form.Item
              label={<div style={{ color: 'white' }}>{t('login.password')}</div>}
              name="password"
              rules={[{ required: true, message: t('login.help_password') }]}
            >
              <Input.Password
                size="large"
                style={{ borderRadius: '2rem' }}
                type="password"
                placeholder={t('login.password')}
              />
            </Form.Item>
            <Form.Item
              label={<div style={{ color: 'white' }}>{t('login.password_again')}</div>}
              name="passwordAgain"
              rules={[{ required: true, message: t('login.help_password_again') }]}
            >
              <Input.Password
                size="large"
                type="password"
                placeholder={t('login.password_again')}
              />
            </Form.Item>
            <Form.Item
              label={<div style={{ color: 'white' }}>{t('login.business')}</div>}
              rules={[{ message: t('login.help_business'), required: true }]}
              name="business_name"
            >
              <Input size="large" placeholder={t('login.business')} />
            </Form.Item>
            <Form.Item
              label={<div style={{ color: 'white' }}>Email</div>}
              rules={[{ message: t('login.help_email'), required: true }]}
              name="email"
            >
              <Input size="large" placeholder="Email" />
            </Form.Item>

            <Row justify="center">
              <Form.Item>
                <Button
                  style={{
                    background: '#000000',
                    borderRadius: '2rem',
                    height: '2.5rem',
                    color: 'white',
                    border: 'none',
                  }}
                  htmlType="submit"
                >
                  {t('login.create_account')}
                </Button>
              </Form.Item>
            </Row>
          </Form>
        )}
      </Col>

      <Col
        style={{ width: '100%', height: '100vh', backgroundColor: 'white', position: 'relative' }}
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={16}
      >
        <img
          src={bgLogin}
          style={{
            width: '100%',
            height: '100vh',
            objectFit: 'cover',
          }}
          alt=""
        />
        <div
          style={{
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            position: 'absolute',
          }}
        />
      </Col>
    </Row>
  )
}
